import { render, staticRenderFns } from "./SalviMusicShopLogo.vue?vue&type=template&id=5903af7e&"
import script from "./SalviMusicShopLogo.vue?vue&type=script&lang=js&"
export * from "./SalviMusicShopLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports